import { useImpactStats } from "@common/queries";
import { StatGrid, StatTile } from "@jkast90/kast-common/ui";

/** The site's four headline numbers, as shared stat tiles. Nothing until the stats are in: no clutter while they load or fail. */
export default function StatsStrip() {
  const { data: stats, isError: error } = useImpactStats();

  if (error || !stats) {
    return null;
  }

  const fmt = (n: number) => n.toLocaleString();

  return (
    <StatGrid>
      <StatTile label="Bags collected" value={fmt(stats.total_bags)} tone="accent" />
      <StatTile label="Locations" value={fmt(stats.total_locations)} tone="accent" />
      <StatTile label="Cleanup events" value={fmt(stats.total_events)} tone="accent" />
      <StatTile label="Volunteers" value={fmt(stats.total_volunteers ?? 0)} tone="accent" />
    </StatGrid>
  );
}
